"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIndex = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
var use_pagination_1 = require("../pagination/use-pagination");
var use_object_change_watcher_1 = require("../use-object-change-watcher/use-object-change-watcher");
var use_index_default_adapter_1 = require("./use-index-default-adapter");
var useIndex = function (options) {
    var fetch = options.fetch, totalCount = options.totalCount, perPage = options.perPage, defaultOrderBy = options.defaultOrderBy, adapter = options.adapter, defaultWhere = options.where, currentPageIndex = options.currentPageIndex, onCurrentPageIndexChange = options.onCurrentPageIndexChange;
    var _a = (0, react_1.useState)(defaultOrderBy), orderBy = _a[0], setOrderBy = _a[1];
    var _b = (0, react_1.useState)(defaultWhere), where = _b[0], setWhere = _b[1];
    var pagination = (0, use_pagination_1.usePagination)({
        total: totalCount || 0,
        perPage: perPage,
        currentPageIndex: currentPageIndex,
        onCurrentPageIndexChange: onCurrentPageIndexChange,
    });
    // Call setWhere when defaultWhere (props.where) is changed
    (0, use_object_change_watcher_1.useObjectChangeWatcher)(defaultWhere, setWhere);
    // Fetch data
    (0, react_1.useEffect)(function () {
        // Get adapter AKA. function that remap query parameter
        var localAdapter = adapter || use_index_default_adapter_1.useIndexDefaultAdapter;
        // Call adapter
        var queryArgs = localAdapter({
            orderBy: orderBy,
            skip: pagination.skip,
            take: perPage,
            where: where,
        });
        // Fetch
        fetch(queryArgs);
    }, [pagination.skip, orderBy, fetch, adapter, perPage, where]);
    // Change orderBy state
    var handleSetOrderBy = (0, react_1.useCallback)(function (column) {
        var _a;
        // Default orderby
        var order = 'asc';
        // Get current orderBy key from state
        var currentField = lodash_1.default.chain(orderBy).keys().first().value();
        // Get current orderBy sort order from state
        var currentOrder = lodash_1.default.chain(orderBy).values().first().value();
        // Check if current field is same than previous sort and order is ASC and reverse order
        if (currentField === column.field && currentOrder === 'asc') {
            order = 'desc';
        }
        // Update orderBy state
        setOrderBy((_a = {}, _a[column.field] = order, _a));
    }, [setOrderBy, orderBy]);
    return {
        pagination: pagination,
        orderBy: orderBy,
        setOrderBy: handleSetOrderBy,
    };
};
exports.useIndex = useIndex;
